/**
 * Freemium ribbon visibility.
 *
 * Single source of truth: localStorage only (fetchData + total_device_count).
 * No cookies, no sessionStorage — both can be wiped or poisoned by
 * Shopify's cross-origin checkout navigation.
 *
 * Rule: show if fetchData present AND eligible (≥200 devices) AND not subscribed.
 *       If fetchData not yet available → null → leave CSS default, do nothing.
 */
(function () {
  function subscribedSkusFromFetchData(raw) {
    if (!raw) return [];
    try {
      var data = typeof raw === 'string' ? JSON.parse(raw) : raw;
      var skus =
        (data.subscriber_list && data.subscriber_list.subscribed_products) ||
        data.records ||
        [];
      return Array.isArray(skus) ? skus : [];
    } catch (e) {
      return [];
    }
  }

  // Returns true (show), false (hide), or null (no fetchData yet — no-op).
  window.ds2ShouldShowPremFreeRibbon = function () {
    var raw = localStorage.getItem('fetchData');
    if (!raw) return null;

    var totalDeviceCount = parseInt(localStorage.getItem('total_device_count'), 10);
    if (!Number.isFinite(totalDeviceCount) || totalDeviceCount < 200) return false;

    var prem = window.PREM_REPORT;
    if (!prem) return false;

    var skus = subscribedSkusFromFetchData(raw);
    var alreadySubscribed = skus.some(function (sku) {
      var s = String(sku);
      return s === prem || s.indexOf(prem) !== -1;
    });

    return !alreadySubscribed;
  };

  window.ds2ApplyPremFreeRibbonVisibility = function () {
    var show = window.ds2ShouldShowPremFreeRibbon();
    if (show === null) return; // no data yet — leave CSS alone

    var display = show ? 'block' : 'none';

    document.querySelectorAll('#prem_report_card').forEach(function (el) {
      el.style.display = display;
    });

    var premBox = document.getElementById('prem_reports_box');
    if (premBox) {
      if (show) {
        premBox.style.display = 'block';
      } else {
        premBox.style.setProperty('display', 'none', 'important');
      }
    }
  };

  // Backward-compat stubs — no longer do anything.
  window.ds2ClearPremFreeRibbonOverride = function () {};
  window.ds2SyncPremFreeRibbonOverrideFromCart = function () {};
  window.ds2RefreshPremFreeRibbonFromCart = function () {
    window.ds2ApplyPremFreeRibbonVisibility();
    return Promise.resolve();
  };
  window.handlePremReportDisplay = function () {
    window.ds2ApplyPremFreeRibbonVisibility();
  };

  function scheduleApply() {
    requestAnimationFrame(function () {
      window.ds2ApplyPremFreeRibbonVisibility();
    });
  }

  if (!window.__premFreemiumRibbonInit) {
    window.__premFreemiumRibbonInit = true;
    document.addEventListener('DOMContentLoaded', scheduleApply);
    document.addEventListener('apiCallsComplete', scheduleApply);
    document.addEventListener('product-grid:updated', scheduleApply);
    document.addEventListener('shopify:section:load', scheduleApply);
  }
})();
